import publicity from './myPublicity';
import publicityDetails from './details';

export default [publicity, publicityDetails];
